import React from 'react';
import Link from 'gatsby-link';
import Radium from 'radium';

import sharedStyles from '../shared/sharedStyles';

import ProjectScreenshot from './projectScreenshot';

import SectionHeading from "./sectionHeading";

import rcr    from '../assets/images/apps/rcr.png';
import rcc    from '../assets/images/apps/rcc.png';
import bcj    from '../assets/images/apps/bcj.png';
import DBAb   from '../assets/images/apps/DBAb.png';
import slama_F from '../assets/images/apps/SLAMAf.png';
import dbd_f  from '../assets/images/apps/ddbd_frame.png';
import dbd_w  from '../assets/images/apps/ddbd_w.png';
import dbd_d  from '../assets/images/apps/ddbd_dual.png';
import dbd_p  from '../assets/images/apps/ddbd_p.png';
import ldm    from '../assets/images/apps/ldm.png';

import DottedCircle from './decorations/dottedCircle';
import Circle       from './decorations/circle';
import Triangle     from './decorations/triangle';

const generateLink = (link, currentPath) => {
    const isLinkEN = currentPath.search('/en/');
        const isLinkIT = currentPath.search('/it/');
            if((isLinkEN != -1)||((isLinkEN == -1)&&(isLinkIT == -1))) return '/en/' + link
                else return '/it/' + link
                };


class Appshelf extends React.Component {

  render() {

      return (
        <section id="work-section" className="diagonal clockwise" style={styles.section}>

      <div style={styles.projectsContainer}>
             <div id="project1" style={styles.screenshot}><Link to={generateLink("rcr", this.props.pathname)}><ProjectScreenshot screenshotURL={rcr} description="RC Section - Rect" /></Link></div>
             <div id="project6" style={styles.screenshot}><Link to={generateLink("rcc", this.props.pathname)}><ProjectScreenshot screenshotURL={rcc} description="RC Section - Circ" /></Link></div>
             <div id="project2" style={styles.screenshot}><Link to={generateLink("bcj", this.props.pathname)}><ProjectScreenshot screenshotURL={bcj} description="Beam - Column Joint" /></Link></div>
             <div id="project2" style={styles.screenshot}><Link to={generateLink("DBAb", this.props.pathname)}><ProjectScreenshot screenshotURL={DBAb} description="DBA bridge" /></Link></div>
             <div id="project2" style={styles.screenshot}><Link to={generateLink("SLaMAf", this.props.pathname)}><ProjectScreenshot screenshotURL={slama_F} description="SLaMA Solver Frame" /></Link></div>
             <div id="project3" style={styles.screenshot}><Link to={generateLink("dbd_f", this.props.pathname)}><ProjectScreenshot screenshotURL={dbd_f} description="DBD - Frame" /></Link></div>
             <div id="project4" style={styles.screenshot}><Link to={generateLink("dbd_w", this.props.pathname)}><ProjectScreenshot screenshotURL={dbd_w} description="DBD - Wall" /></Link></div>
             <div id="project5" style={styles.screenshot}><Link to={generateLink("dbd_d", this.props.pathname)}><ProjectScreenshot screenshotURL={dbd_d} description="DBD - Dual system" /></Link></div>
             <div id="project6" style={styles.screenshot}><Link to={generateLink("dbd_p", this.props.pathname)}><ProjectScreenshot screenshotURL={dbd_p} description="DBD - Pier" /></Link></div>
      </div>
  </section>
  );
  }

}


var styles = {};

styles.section = {
  background: "white",
  position: "relative"
}

styles.container = {
  marginTop: "3%",
  padding: 0,
  marginBottom: "7%"
}

styles.featuredImage = {
  width: "20%",
  position: "relative",
  zIndex: 1
}

styles.shadowImage = {
  position: "relative",
  left: "-100px",
  opacity: 0
}

styles.imageBefore = {
  position: "absolute",
  width: "102%",
  height: "92%",
  top: "-6%",
  left: 0,
  background: "#a8e4bc",
  zIndex: -1
}

styles.rightHalf = {
  padding: "3% 6%",
  position: "relative",
  top: "-100px",
  opacity: 0
}

styles.projectsLink = {
  textAlign: "center",
  marginTop: "3%",
  fontSize: "3vh"
}

styles.p = {
  fontFamily: "RobotoMono-Regular",
  fontSize: "30px",
  color: "black",
  lineHeight: "1.7"
}

styles.projectsContainer = {
  width: "100%",
  position: "relative",
  paddingBottom: "8%"
}

styles.projectsFlex = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
}

styles.screenshot = {
  display: "inline-block",
  width: "100%",
  "@media screen and (min-width: 768px)": {
  width: "calc(33.3333%)"
  }
}

export default Radium(Appshelf);



// WEBPACK FOOTER //
// ./src/components/appshelf.jsx